var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form__control"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',_vm._g(_vm._b({domProps:{"value":_vm.value},on:{"input":_vm.updateValue}},'input',_vm.$attrs,false),_vm.listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }